import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToasterService } from '@core-services';
import { TranslateService } from '@ngx-translate/core';
import { catchError, throwError } from 'rxjs';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toasterService = inject(ToasterService);
  const translation = inject(TranslateService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      switch (error.status) {
        case 401:
          toasterService.showErrorMessage(translation.instant('HttpErrors.Unauthorized'));
          break;
        case 400:
          toasterService.showErrorMessage(error.error.message);
          break;
        default:
          toasterService.showErrorMessage(error.statusText);
          break;
      }
      return throwError(() => new Error(error.message));
    }),
  );
};
